//#region frontend/islands/breed-search.js
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn(...args), wait);
	};
}
var BreedSearch = class extends HTMLElement {
	connectedCallback() {
		this.targetId = this.dataset.targetId;
		this.activeIdx = -1;
		this.input = this.querySelector(".breed-search__input");
		this.list = this.querySelector(".breed-search__list");
		const visibleItems = () => [...this.querySelectorAll(".breed-search__item")].filter((btn) => !btn.closest("li").hidden);
		const openList = () => {
			this.list.hidden = false;
			this.input.setAttribute("aria-expanded", "true");
		};
		const closeList = () => {
			this.list.hidden = true;
			this.input.setAttribute("aria-expanded", "false");
			this.setActive(-1, []);
		};
		this.list.addEventListener("pointerdown", (e) => e.preventDefault());
		this.input.addEventListener("focus", openList);
		this.addEventListener("focusout", (e) => {
			if (!this.contains(e.relatedTarget)) closeList();
		});
		this.input.addEventListener("input", debounce(() => {
			const q = this.input.value.trim().toLowerCase();
			this.querySelectorAll(".breed-search__list li").forEach((li) => {
				li.hidden = !li.querySelector(".breed-search__item").dataset.label.toLowerCase().includes(q);
			});
			this.activeIdx = -1;
			openList();
		}, 150));
		this.input.addEventListener("keydown", (e) => {
			const items = visibleItems();
			if (e.key === "ArrowDown") {
				e.preventDefault();
				openList();
				this.setActive(Math.min(this.activeIdx + 1, items.length - 1), items);
			} else if (e.key === "ArrowUp") {
				e.preventDefault();
				if (this.activeIdx > 0) this.setActive(this.activeIdx - 1, items);
			} else if (e.key === "Enter" && this.activeIdx >= 0) {
				e.preventDefault();
				const item = items[this.activeIdx];
				if (item) {
					this.input.value = item.dataset.label;
					closeList();
					this.select(item.dataset.value, item);
				}
			} else if (e.key === "Escape") {
				e.preventDefault();
				closeList();
			}
		});
		this.addEventListener("click", (e) => {
			const breed = e.target.closest(".breed-search__item");
			if (breed) {
				this.input.value = breed.dataset.label;
				closeList();
				this.select(breed.dataset.value, breed);
				return;
			}
			const override = e.target.closest(".radio-card");
			if (override) {
				this.input.value = "";
				this.select(override.dataset.value, override);
			}
		});
	}
	setActive(idx, items) {
		this.querySelectorAll(".breed-search__item.is-active").forEach((el) => el.classList.remove("is-active"));
		this.activeIdx = idx;
		const active = items[idx];
		if (active) {
			active.classList.add("is-active");
			this.input.setAttribute("aria-activedescendant", active.id);
			active.scrollIntoView({ block: "nearest" });
		} else this.input.removeAttribute("aria-activedescendant");
	}
	select(value, el) {
		this.querySelectorAll(".breed-search__item, .radio-card").forEach((btn) => {
			btn.classList.remove("is-selected");
			btn.setAttribute("aria-selected", "false");
		});
		el.classList.add("is-selected");
		el.setAttribute("aria-selected", "true");
		const hidden = document.querySelector(`#${this.targetId}`);
		if (hidden) hidden.value = value;
		const continueBtn = document.querySelector(`[data-quiz-next][data-name="${this.targetId}"]`);
		if (continueBtn) continueBtn.disabled = false;
	}
};
customElements.define("breed-search", BreedSearch);
//#endregion
